import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=d64766fc&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64766fc",
  null
  
)

export default component.exports